import { FC } from 'react';
import { IPointCategoryItemProps } from './types';
import styles from './pointCategoryItem.module.scss';

const PointCategoryItem: FC<IPointCategoryItemProps> = ({
  category: { categoryImage, categoryName },
  classNameProp,
}) => (
  <div className={`${styles.categoryItem} ${classNameProp}`}>
    {categoryImage && <img src={categoryImage} width={18} height={18} alt='' />}
    <p className={styles.categoryName}>{categoryName}</p>
  </div>
);

export default PointCategoryItem;
